import { Pipe, PipeTransform } from '@angular/core';
import { SKWFilter } from '../../models/storekeeper-window.model';

@Pipe({ name: 'isFilterActivePipe', standalone: true })
export class SKWIsFilterActivePipe implements PipeTransform {
  transform(filter: SKWFilter, activeFilters: SKWFilter[] | undefined): boolean {
    return activeFilters?.findIndex(({ value }) => value === filter.value) > -1;
  }
}
